<template>
    <UiHeroCardLayoutContainer :blok="blok" />
</template>

<script setup lang="ts">
import type { IHeroCardLayout } from '@nuxt-monorepo/ui/types/components/HeroCardLayout';

defineProps<{ blok: IHeroCardLayout }>();
</script>

<style scoped lang="postcss">
.hero-card-layout {
    &:has(.hero-card-layout__content) {
        :deep(.ui-hero-card-layout-header) {
            @apply md:pb-24 lg:pb-[80px] lg:pt-20;
        }
    }
}
</style>
